import { createIcon } from '@chakra-ui/icons'

// using `path`
export const AccountabilityIcon = createIcon({
  displayName: 'Accountability',
  viewBox:"0, 0, 800,800",

  // path can also be an array of elements, if you have multiple paths, lines, shapes, etc.
  path: (
    <g transform="translate(0.000000,700.000000) scale(0.100000,-0.100000)"
fill="black" stroke="none">
<path d="M3470 6889 c-247 -29 -417 -278 -356 -519 33 -128 122 -234 241 -286
l60 -26 -3 -202 c-2 -110 -6 -204 -10 -208 -7 -7 -319 -148 -328 -148 -2 0 -4
82 -4 183 -1 124 -5 189 -13 203 -7 12 -96 93 -199 179 -174 147 -187 160
-180 184 4 14 7 73 7 131 0 98 -2 109 -32 171 -82 168 -272 271 -445 240 -141
-25 -262 -114 -318 -234 -102 -218 -12 -467 206 -569 122 -57 278 -48 389 23
25 16 48 29 51 29 3 0 72 -56 154 -125 l150 -126 0 -179 0 -179 -67 -21 c-122
-38 -365 -98 -501 -125 -74 -14 -142 -30 -151 -35 -44 -23 -46 -34 -51 -269
l-5 -226 -102 -3 -102 -3 -127 152 -127 152 17 26 c76 116 97 251 56 370 -38
114 -123 210 -228 259 -51 24 -69 27 -172 27 -111 0 -118 -1 -183 -33 -320
-158 -319 -606 2 -765 61 -30 73 -32 166 -32 55 0 114 4 131 8 30 8 33 4 173
-163 200 -238 172 -220 352 -220 l149 0 0 -140 0 -140 -224 0 c-123 0 -231 -3
-240 -6 -9 -3 -16 -1 -16 6 0 25 -53 120 -91 164 -84 96 -194 146 -319 146
-165 0 -311 -94 -387 -249 -26 -51 -28 -66 -28 -171 0 -109 2 -119 32 -183 62
-131 180 -223 320 -249 177 -33 374 75 448 245 l29 67 238 0 238 0 0 -185 0
-185 -127 0 c-71 0 -144 -5 -164 -10 -30 -8 -63 -42 -194 -199 -140 -167 -161
-188 -180 -181 -83 31 -220 18 -318 -32 -244 -123 -308 -456 -126 -653 98
-106 203 -150 341 -142 158 8 285 92 355 235 37 73 38 80 38 181 0 95 -3 112
-28 166 -15 33 -35 67 -43 77 -9 9 -14 21 -13 27 2 6 58 75 124 155 l120 145
107 0 106 1 46 -80 46 -79 0 -215 c0 -118 4 -226 10 -240 11 -30 65 -66 98
-66 32 0 79 26 94 53 7 12 15 54 18 93 l5 72 75 -85 c129 -145 379 -358 553
-472 l67 -43 0 -285 0 -285 34 -34 c38 -38 77 -44 125 -19 54 27 61 61 61 289
l0 205 82 -39 c45 -22 91 -40 102 -40 27 0 138 52 274 127 128 71 225 135 348
229 46 35 86 64 89 64 3 0 5 -50 5 -111 0 -109 0 -111 29 -140 24 -23 38 -29
73 -29 24 0 54 7 67 16 44 31 51 69 51 280 l0 197 78 86 c153 168 296 355 383
504 l34 57 111 0 112 0 126 -151 126 -151 -24 -31 c-14 -18 -34 -56 -45 -86
-59 -150 -25 -314 90 -436 206 -218 555 -161 686 111 146 305 -118 652 -453
595 -42 -7 -79 -10 -82 -6 -4 3 -74 86 -157 183 -82 97 -161 182 -175 189 -17
8 -73 13 -167 13 l-143 0 0 185 0 185 249 0 249 0 7 -30 c9 -41 74 -139 120
-179 22 -19 67 -47 101 -63 161 -75 335 -49 467 72 223 203 164 561 -113 694
-61 29 -73 31 -175 31 -104 0 -114 -2 -178 -33 -90 -44 -164 -119 -202 -205
l-30 -66 -242 -1 -243 0 0 140 0 140 149 0 c82 0 157 3 166 6 9 4 88 91 176
195 l159 188 32 -10 c18 -5 69 -9 114 -9 174 0 312 88 388 249 29 61 31 74 31
171 0 97 -2 110 -32 172 -53 113 -146 196 -262 233 -40 13 -76 16 -146 13 -79
-3 -101 -8 -158 -37 -128 -62 -213 -177 -238 -320 -17 -94 10 -206 70 -297
l21 -30 -127 -152 -126 -152 -108 0 -109 0 0 211 c0 222 -6 259 -48 286 -10 6
-68 21 -128 33 -135 27 -276 61 -416 102 l-108 31 0 192 0 193 151 126 151
126 32 -20 c168 -112 377 -96 521 41 100 94 140 196 133 334 -8 153 -94 282
-235 352 -63 31 -87 37 -157 41 -140 7 -240 -33 -335 -133 -94 -99 -131 -225
-107 -363 l12 -73 -180 -152 c-114 -95 -188 -165 -198 -187 -15 -30 -18 -64
-18 -219 0 -170 -1 -183 -17 -176 -88 33 -320 127 -330 133 -8 5 -12 72 -15
218 l-3 212 64 28 c124 54 220 180 244 321 27 157 -51 331 -187 418 -89 56
-180 76 -286 64z m104 -230 c98 -27 158 -137 132 -240 -31 -118 -167 -179
-277 -123 -66 33 -116 124 -106 195 11 82 55 136 133 164 48 17 68 18 118 4z
m-1226 -104 c105 -44 151 -165 103 -270 -88 -191 -370 -126 -371 84 0 139 143
238 268 186z m2552 -19 c101 -66 118 -201 37 -293 -40 -45 -82 -63 -147 -63
-111 0 -190 79 -190 189 0 87 37 145 115 183 54 25 133 19 185 -16z m-3534
-1052 c116 -55 145 -223 54 -314 -116 -116 -310 -51 -337 113 -12 74 43 173
112 203 42 18 130 17 171 -2z m4437 2 c44 -18 94 -77 108 -128 31 -116 -48
-230 -168 -245 -74 -8 -152 30 -189 93 -45 76 -29 191 32 245 55 48 150 64
217 35z m-2187 -95 c306 -136 657 -250 1007 -326 l77 -17 0 -783 0 -782 -66
-99 c-106 -159 -206 -279 -373 -445 -217 -215 -415 -365 -657 -495 l-104 -56
-108 57 c-393 207 -774 555 -1024 933 l-68 104 0 784 0 784 23 4 c12 3 67 15
122 26 300 62 708 198 960 320 44 21 85 39 91 39 6 1 60 -21 120 -48z m-2340
-1088 c93 -47 129 -181 74 -271 -60 -99 -211 -124 -296 -50 -61 54 -85 131
-64 207 13 50 72 112 120 128 48 16 120 10 166 -14z m4634 5 c65 -34 102 -86
108 -152 11 -131 -66 -216 -196 -216 -76 0 -139 38 -171 102 -81 169 94 349
259 266z m-4542 -1276 c102 -46 138 -199 70 -295 -24 -34 -109 -77 -152 -77
-113 0 -207 94 -206 206 1 66 75 166 133 178 52 12 64 13 92 8 17 -2 45 -11
63 -20z m4417 13 c59 -12 134 -112 135 -179 1 -111 -93 -206 -204 -206 -61 0
-141 53 -173 114 -43 82 -1 210 82 254 56 29 86 32 160 17z"/>
<path d="M3320 4954 c-112 -21 -240 -70 -342 -130 -106 -63 -257 -212 -321
-315 -149 -241 -191 -528 -117 -796 92 -333 367 -602 710 -695 72 -19 109 -23
245 -22 135 0 173 3 245 23 342 92 601 344 707 688 25 82 27 101 27 268 1 159
-2 189 -22 260 -102 351 -367 613 -708 701 -129 33 -303 40 -424 18z m349
-240 c144 -32 310 -135 407 -252 118 -143 176 -303 177 -487 0 -133 -19 -219
-73 -330 -38 -78 -105 -175 -125 -182 -5 -1 -26 27 -45 65 -49 95 -145 188
-247 239 l-81 41 39 21 c64 36 130 111 166 188 162 341 -167 712 -529 597 -77
-25 -163 -87 -213 -155 -148 -201 -98 -476 113 -621 l44 -30 -74 -36 c-96 -48
-209 -160 -257 -254 l-33 -66 -28 31 c-120 138 -190 351 -176 537 14 201 95
372 240 507 187 175 440 243 695 187z m-104 -315 c23 -7 57 -28 81 -53 85 -84
85 -208 0 -292 -84 -85 -208 -85 -292 0 -82 82 -85 203 -6 288 57 60 132 80
217 57z m90 -823 c93 -46 180 -160 187 -246 3 -33 1 -35 -62 -61 -136 -57
-294 -73 -437 -43 -93 19 -203 67 -203 88 0 40 45 130 91 181 109 119 279 151
424 81z"/>
<path d="M4720 2992 c-81 -81 -16 -218 93 -198 74 14 110 103 72 176 -19 37
-43 50 -95 50 -32 0 -48 -6 -70 -28z"/>
<path d="M2233 2596 c-48 -22 -68 -60 -68 -132 0 -74 22 -111 77 -132 30 -12
40 -11 71 1 45 19 69 56 75 115 10 108 -70 185 -155 148z"/>
<path d="M4614 2486 l-34 -34 0 -250 0 -250 26 -31 c47 -57 137 -50 175 13 17
28 19 54 19 264 0 256 -4 278 -60 307 -49 25 -88 19 -126 -19z"/>
<path d="M2613 2350 c-49 -29 -55 -69 -51 -329 3 -243 5 -253 59 -285 50 -29
114 -15 146 33 16 23 18 56 21 252 4 261 -2 300 -51 329 -18 11 -45 20 -62 20
-16 0 -44 -9 -62 -20z"/>
<path d="M3958 2185 c-51 -29 -58 -58 -58 -246 l0 -171 34 -34 c29 -29 41 -34
79 -34 34 0 53 6 74 24 l28 24 3 190 3 190 -28 32 c-34 38 -93 49 -135 25z"/>

</g>
    
  ),
})
